<template>
  <div class="contents">
    <common-header
      :menu="headerMenu"
      :mute="mute"
      :camera-mode="currentCameraMode"
      @button-clicked="onButtonClicked"
      @camera-mode-change="onCameraChange" />
    <settings-modal ref="settings" :settings="settings"
                    :display-value="displayValue"
                    @camera-mode-change="onCameraChange"
                    @settings-change="onSettingChange" />
    <common-display :debug-meg="debugMeg" :navigations="navigations" />
    <side-menu v-show="canShowSideMenu" :menu="sideMenu"
               @button-clicked="onButtonClicked" />
    <section v-show="canShowHeaderMenu" class="score-boards">
      <score-board title="回数" :value="score" unit="回" :min-length="4" class="score-borad" />
    </section>
    <title-label :title="title"/>
    <common-modal ref="modal" :steps="steps"/>
    <fill-camera-layout
      @camera-required="start"
      :device-state="deviceState"
      :camera-state="manager ? manager.state : null"/>
    <common-footer v-show="canShowFooterMenu" :menu="footerMenu" />
  </div>
</template>

<script>
import "@pqina/flip/dist/flip.min.css";
import {Crunch} from '../game/Crunch'
import SettingButton from "../SettingButton";
import Separator from "../Separator";
import CommonHeader from "../CommonHeader";
import {CAMERA_MODE} from '../common/CameraRenderer'
import {CommonMixin} from '../common/CommonMixin'
import FillCameraLayout from "../FillCameraLayout";
import CommonDisplay from "../CommonDisplay";
import CommonFooter from "../CommonFooter";
import ScoreBoard from "../common/ScoreBoard";
import SettingsModal from "../common/SettingsModal";
import CommonModal from "../common/CommonModal";
import SideMenu from "../SideMenu";
import TitleLabel from "../common/TitleLabel";

export default {
  name: 'Crunch',
  mixins: [CommonMixin],
  components: {TitleLabel, SideMenu, CommonModal, SettingsModal, ScoreBoard, CommonFooter, CommonDisplay, FillCameraLayout, CommonHeader, Separator, SettingButton},
  data () {
    return {
      showScore: false,
      defaultCameraMode: CAMERA_MODE.FIGURE,
      headerMenu: Object.assign({}, this.defaultHeaderMenu(), {  }),
      sideMenu: Object.assign({}, this.defaultSideMenu(), {}),
      footerMenu: Object.assign({}, this.defaultFooterMenu(), {}),
      settings: [
        { key: 'punchThreshold', type: 'range', label: '起きた姿勢の検出閾値', default: 1.15, step:0.01, min:1.05, max:1.5 },
        { key: 'resetThreshold', type: 'range', label: '元の姿勢の検出閾値', default: 1.10, step:0.01, min:1.01, max:1.5 },
      ],
      steps: [
        'カメラから少し離れて、仰向けに寝た姿勢になります',
        '頭と腰が両方映っていれば「スタート」の音声が流れます',
        '上体を起こせば「ドン」戻せば「カッ」という音が鳴ります',
      ],
    }
  },
  computed: {
    title() {
      return 'クランチ'
    },
    desc() {
      return '毎日の筋トレをWebカメラで自動計測するツール'
    },
  },
  methods: {
    createContents() {
      return new Crunch();
    },
    setScores() {
      this.score = Math.round(this.manager.game.score)
      this.navigations = this.manager.game.navigations
      this.debugMeg = this.manager.game.debug
    }
  }
}
</script>

<style scoped>
.score-borad {
  margin: 0 auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/contents-page/Crunch.vue